<div class="heatmap-wrapper">
  <div #heatmapMap class="heatmap-map"></div>
</div>